import React from 'react';

/**
 * Shared state for the gender-pair UI inside a voc relations tree.
 * - `treeIds`: ids of every node currently rendered in the tree, so a node can tell
 *   whether its gender pair lives in the same tree (and thus supports reciprocal hover).
 * - `hoveredIds` / `setHoveredIds`: the pair being hovered. When a paired node is hovered
 *   and its partner is in the same tree, both ids are set so both cards highlight at once.
 */
export type IGenderPairContext = {
  treeIds: Set<number>;
  hoveredIds: number[] | null;
  setHoveredIds: (ids: number[] | null) => void;
};

export const GenderPairContext = React.createContext<IGenderPairContext>({
  treeIds: new Set<number>(),
  hoveredIds: null,
  setHoveredIds: () => undefined,
});
